import './style.scss';

import React from 'react';
import _ from 'lodash';

export default class extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      dragging: false,
      handleLeft: 0
    };

    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.setState({ handleLeft: this.getHandleLeft(this.props.selectedOption) });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ handleLeft: this.getHandleLeft(nextProps.selectedOption) });
  }

  labelRefName(option) {
    return `labelRef_${option}`;
  }

  getHandleLeft(selectedOption) {
    const selectedLabel = this[this.labelRefName(selectedOption)];
    const left = selectedLabel && selectedLabel.offsetLeft;
    return left;
  }

  handleMouseDown(event) {
    event.preventDefault();

    this._startDrag(event, {
      moveEvent: 'mousemove',
      endEvent: 'mouseup'
    });
  }

  handleTouchStart(event) {
    const touch = this._getTouch(event);
    if (!touch) return;

    this._startDrag(touch, {
      moveEvent: 'touchmove',
      endEvent: 'touchend'
    });
  }

  _getTouch(event) {
    const touchList = event.touches;
    if (!touchList || touchList.length !== 1) return; // e.g. user uses two fingers
    return touchList[0];
  }

  _startDrag(initEvent, { moveEvent, endEvent }) {
    this.setState({ dragging: true });

    const startX = initEvent.clientX;

    const slider = this.sliderRef;
    const handle = this.handleRef;
    const startLeft = handle.offsetLeft;
    const maxLeft = slider.clientWidth - handle.clientWidth;

    handle.style.transition = 'none';

    const handleMove = initEvent.type === 'mousedown' ?
      this._handleMouseMove.bind(this, startX, startLeft, maxLeft, handle) :
      this._handleTouchMove.bind(this, startX, startLeft, maxLeft, handle);

    document.body.addEventListener(moveEvent, handleMove);
    document.body.addEventListener(endEvent, () => {
      document.body.removeEventListener(moveEvent, handleMove);
      this._handleDragEnd(slider, handle);
    }, { once: true });
  }

  _handleMouseMove(startX, startLeft, maxLeft, handle, event) {
    const amountMoved = event.clientX - startX;
    this._applyAmountMoved(amountMoved, startLeft, maxLeft);
  }

  _handleTouchMove(startX, startLeft, maxLeft, handle, event) {
    const touch = this._getTouch(event);
    if (!touch) return;
    const amountMoved = touch.clientX - startX;
    this._applyAmountMoved(amountMoved, startLeft, maxLeft);
  }

  _applyAmountMoved(amountMoved, startLeft, maxLeft) {
    this._directionMoved = amountMoved >= 0 ? 'right' : 'left';
    let newLeft = startLeft + amountMoved;
    if (newLeft < 0) newLeft = 0;
    if (newLeft > maxLeft) newLeft = maxLeft;
    this.setState({ handleLeft: newLeft });
  }

  _handleDragEnd(slider, handle) {
    const droppableWidth = slider.clientWidth / this.props.options.length;
    const handleLeft = handle.offsetLeft;
    const handleRight = handleLeft + handle.clientWidth;

    let selectedIdx;

    if (this._directionMoved === 'left') {
      let gates = this.props.options.map((_, idx) => (idx + 1) * droppableWidth)
      selectedIdx = _.findIndex(gates, (gate) => handleLeft <= gate);
    } else {
      let gates = this.props.options.map((_, idx) => idx * droppableWidth)
      selectedIdx = _.findLastIndex(gates, (gate) => handleRight >= gate);
    }

    handle.style.transition = '';

    const selectedOption = this.props.options[selectedIdx];

    this.setState({
      dragging: false,
      handleLeft: this.getHandleLeft(selectedOption)
    });

    this.props.onChange(selectedOption);
  }

  handleChange(event) {
    this.props.onChange(event.target.value);
  }

  render() {
    return (
      <div
        className={`radio-slider ${this.state.dragging ? "radio-slider--dragging" : ""}`}
        onMouseDown={this.handleMouseDown}
        onTouchStart={this.handleTouchStart}
        ref={(div) => { this.sliderRef = div }}
      >
        <div
          className="radio-slider__handle"
          style={{ left: `${this.state.handleLeft}px` }}
          ref={(div) => {this.handleRef = div }}
        ></div>

        { this.props.options.map((option) => {

          const id = `${ this.props.name }_${option}`;
          const isChecked = this.props.selectedOption === option;
          const className = [
            'radio-slider__label',
            isChecked ? "radio-slider__label--checked" : "",
            this.state.dragging ? "radio-slider__label--dragging" : ""
          ].join(' ');

          return (
            <label
              className={ className }
              htmlFor={ id }
              key={ id }
              ref={(label) => this[this.labelRefName(option)] = label}
            >
              <input
                className="radio-slider__input"
                type="radio"
                name={ this.props.name }
                id={ id }
                value={ option }
                checked={ isChecked }
                onChange={ this.handleChange }
              />
              <span>{option}</span>
            </label>
          );
        }) }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/components/ui/radioSlider/index.js